/* prettier-ignore */

import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { catchError, of, throwError } from 'rxjs';
import { SendUpdateRouteService } from 'src/app/pages/send-update-route/send-update-route.service';
import Swal from'sweetalert2';

@Component({
  selector: 'header-tech-update',
  templateUrl: './tech-update-route.component.html',
  styleUrl: './tech-update-route.component.scss',
})

export class HeaderTechUpdateRouteComponent {

    constructor(
        private sendUpdateService: SendUpdateRouteService,
        public translate: TranslateService,
    ) {}

    updateRoute(){
        this.sendUpdateService.updatedRoute()
            .pipe(
                catchError((error) => {
                    Swal.fire({ icon: 'error', title: '', text: this.translate.instant('Ha ocurrido un error al actualizar la ruta') })
                    return throwError(() => new Error('HTTP request failed', { cause: error }));
                }),
            )
            .subscribe(response => {
                Swal.fire({
                    title: '',
                    text: this.translate.instant('La ruta ha sido actualizada'),
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK',
                    timer: 2500,
                    timerProgressBar: true,
                })
            });
    }


}